<template>
  <v-chip v-bind="$attrs" :style="chipStyle" >
    {{label}}
  </v-chip>
</template>

<script>
import colorMixin from "@/components/mixins/ColorMixin";

export default {
  name: "AgencyStatusChip",
  mixins: [colorMixin],
  inheritAttrs: false,
  props: {
    value: { type:String, default: 'innactive' }, // 'validated' | 'innactive' | 'pending',
  },
  computed: {
    config() {
      return this.agencyStatusColors(this.value) || this.agentActiveColors('innactive')
    },
    label() {
      return this.config.label
    },
    chipStyle() {
      return {
        backgroundColor: this.config.backgroundHex,
        color: this.config.colorHex
      }
    }
  },
}
</script>


<style scoped>

</style>